import { useEffect, useRef, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { UserContext } from "../contexts/UserContext";

export default function useSessionExpired() {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isHandlingRef = useRef(false);

  const handleSessionExpired = useCallback(() => {
    if (isHandlingRef.current) return;
    if (!user) return;
    isHandlingRef.current = true;

    setUser(null);
    toast.error(t("auth.session_expired"));
    navigate("/login", { replace: true });

    setTimeout(() => {
      isHandlingRef.current = false;
    }, 3000);
  }, [user, setUser, navigate, t]);

  useEffect(() => {
    window.addEventListener("session-expired", handleSessionExpired);
    return () => window.removeEventListener("session-expired", handleSessionExpired);
  }, [handleSessionExpired]);
}
